"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _StudioLogger = require("@studio/logger/StudioLogger");
var _StudioPDFThumbnail = require("./StudioPDFThumbnail.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var logger = new _StudioLogger.StudioLogger('pdf-thumbnail');
var StudioPDFThumbnail = function StudioPDFThumbnail(props) {
  var maxWidth = props.maxWidth,
    maxHeight = props.maxHeight,
    pageNumber = props.pageNumber,
    _props$onRenderSucces = props.onRenderSuccess,
    onRenderSuccess = _props$onRenderSucces === void 0 ? function () {} : _props$onRenderSucces;
  var _useState = (0, _react.useState)(1),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    renderedPage = _useState2[0],
    setRenderedPage = _useState2[1];
  var _useState3 = (0, _react.useState)({
      width: maxWidth,
      height: maxHeight
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    presentationDimension = _useState4[0],
    setPresentationDimension = _useState4[1];
  var onError = function onError(error) {
    console.error(error);
    logger.error('Unable to render thumbnail', error);
  };
  var onSuccess = function onSuccess(pageData) {
    var height = pageData.height,
      width = pageData.width,
      _renderedPage = pageData.pageNumber;
    var ratio = Math.min(maxWidth / width, maxHeight / height);
    setPresentationDimension({
      width: width * ratio,
      height: height * ratio
    });
    setTimeout(function () {
      setRenderedPage(_renderedPage);
      onRenderSuccess(pageData);
    }, 500);
  };
  var isLoading = pageNumber !== renderedPage;
  if (pageNumber === 0) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StudioPDFThumbnail.ActiveThumbnail, (0, _extends2["default"])({}, props, {
    presentationDimension: presentationDimension,
    onGetAnnotationsError: onError,
    onGetStructTreeError: onError,
    onGetTextError: onError,
    onLoadError: onError,
    onRenderAnnotationLayerError: onError,
    onRenderError: onError,
    isLoading: isLoading,
    onRenderSuccess: onSuccess,
    onRenderTextLayerError: onError,
    renderAnnotationLayer: false,
    renderTextLayer: false,
    loading: ''
  })), /*#__PURE__*/_react["default"].createElement(_StudioPDFThumbnail.RenderedThumbnail, (0, _extends2["default"])({}, props, {
    pageNumber: renderedPage,
    presentationDimension: presentationDimension,
    onGetAnnotationsError: onError,
    onGetStructTreeError: onError,
    onGetTextError: onError,
    onLoadError: onError,
    onRenderAnnotationLayerError: onError,
    onRenderError: onError,
    onRenderTextLayerError: onError,
    renderAnnotationLayer: false,
    renderTextLayer: false,
    loading: ''
  })));
};
var _default = exports["default"] = StudioPDFThumbnail;